import React from 'react';

import './ProgressScanningTodaySummary.scss';
import { HubSortListOrderEntry } from '../../hooks/useFetchHubSortList';

export interface ParsedScannedOrders {
  remaining: number;
  inProgress: number;
  completed: number;
}

export function parseScannedOrders(
  orders: HubSortListOrderEntry[] = []
): ParsedScannedOrders {
  const filteredOrders = orders.filter(
    ({ order }) => order.status !== 'canceled'
  );
  return {
    remaining: filteredOrders.filter(o => o.scannedParcelCount === 0).length,
    inProgress: filteredOrders.filter(
      o =>
        o.scannedParcelCount > 0 && o.scannedParcelCount < o.preciseParcelCount
    ).length,
    completed: filteredOrders.filter(
      o => o.scannedParcelCount >= o.preciseParcelCount
    ).length,
  };
}
export function ProgressScanningTodaySummary({ scannedOrders }) {
  const status = scannedOrders || {
    remaining: 'N/A',
    inProgress: 'N/A',
    completed: 'N/A',
  };
  return (
    <div className="scan-progress">
      <div className="scan-progress__box">
        <div className="scan-progress__box__label">Gjenstående</div>
        <div className="scan-progress__box__number">{status.remaining}</div>
      </div>
      <div className="scan-progress__box">
        <div className="scan-progress__box__label">Ikke Fullført</div>
        <div className="scan-progress__box__number">{status.inProgress}</div>
      </div>
      <div className="scan-progress__box">
        <div className="scan-progress__box__label">Skannet</div>
        <div className="scan-progress__box__number">{status.completed}</div>
      </div>
    </div>
  );
}
